import React from "react";
import { ApiHook } from "../../hooks/apiHook";
import { Button, Box } from "@mui/material";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { Card } from "react-bootstrap";
import FolderIcon from "@mui/icons-material/Folder"; // Fallback icon
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

export default function Resources() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const folders = ApiHook.Calllms();

  const handleFolderClick = (folder) => {
    navigate(`/folder-view/${folder.id}`, {
      state: {
        folderUrl: folder.videoUrl, // Adjust if your API uses different property names
        title: folder.name,
        back: "",
      },
    });
  };

  const getFileIcon = (isFolder) =>
    isFolder ? (
      <FolderIcon fontSize="large" />
    ) : (
      <InsertDriveFileIcon fontSize="large" />
    );

  return (
    <>
      <div className="page_head_top">{t("Templates")}</div>

      <Box>
        <div className="row">
          <div className="col-md-12">
            <div style={{ float: "right", margin: "10px" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate("/acadamy-dashboard")}
              >
                {t("dashboard")}
              </Button>
            </div>
          </div>
        </div>
      </Box>

      <Box sx={{ p: 2 }}>
        <div className="row">
          {folders?.data?.data?.data?.map((folder, i) => (
            <div
              key={i}
              className="col-md-4 mb-3 d-flex justify-content-center"
              onClick={() => handleFolderClick(folder)}
              style={{ cursor: "pointer" }}
            >
              <Card className="h-100 file-item w-100">
                <Card.Body className="d-flex align-items-center">
                  <div className="me-3">
                    {getFileIcon("folder" === "folder")}
                  </div>
                  <div className="flex-grow-1">
                    <div className="fw-bold">{folder.title}</div>
                    <div className="text-muted small"></div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      </Box>
    </>
  );
}
